export default __webpack_public_path__ + "static/media/square.6f008c28.svg";